import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericModal } from 'src/app/interface/data.interface';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss']
})
export class SuccessModalComponent implements OnInit {
  title: string = 'modal.changesSaved'
  subtitle!: string;
  labelButtonSave: string = 'modal.button.continue'
  labelButtonCancel?: string;

  constructor(
    private matDialogRef: MatDialogRef<SuccessModalComponent>,
    @Inject(MAT_DIALOG_DATA) private payload?: GenericModal) {

    if (this.payload && this.payload.title) {
      this.title = payload.title;
    }

    if (this.payload?.labelButtonSave) {
      this.labelButtonSave = this.payload.labelButtonSave;
    }

    if (this.payload?.labelButtonCancel) {
      this.labelButtonCancel = this.payload.labelButtonCancel;
    }

    if (this.payload?.subtitle) {
      this.subtitle = this.payload.subtitle;
    }
  }

  ngOnInit(): void {
  }

  onEventAccept(event: boolean) {
    this.matDialogRef.close(event);
  }

  onEventCancel(event: boolean) {
    this.matDialogRef.close(event);
  }
}
